export const AssetTypeOptions = [
  { value: "", label: "Select a type" },
  { value: "World", label: "World" },
  // { value: "GeographicalElement", label: "Geographical Element" },
  { value: "Organization", label: "Faction" },
  { value: "Location", label: "Location" },
  { value: "Character", label: "NPC" },
  { value: "Item", label: "Item" },
  { value: "Event", label: "Event" },
  { value: "Beast", label: "Beast" },
  { value: "Quest", label: "Quest" },
  { value: "Encounter", label: "Encounter" },
  { value: "Folder", label: "Folder" },
];
